import get from 'lodash/get';

import { getOauthPartnerId } from 'src/common/components/auth/oauthProvider/getPartnerParams';

export default function findPartnerInfo(location, partners) {
  return get(partners, getOauthPartnerId(location), {});
}
